import Vue from 'vue'


//时间戳转换
Vue.filter('valTime', function (value) {
    if (value) {
        function timestampToTime(timestamp) {
            var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() + ' ';
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var s = date.getSeconds();
            return Y + M + D + h + m + s;
          }
          return timestampToTime(value);
    }else {
        return value
    }
    
})

//年月日
Vue.filter('valTimeTwo', function (value) {
  function timestampToTime(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds();
    return Y + M + D;
  }
  return timestampToTime(value);
})



//金额保留两位小数
Vue.filter('priceTwo', function (value) {
    let price = 0;
    var value = Math.round(parseFloat(value) * 100) / 10000;
    var xsd = value.toString().split(".");
    if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
    }
    if (xsd.length > 1) {
        if (xsd[1].length < 2) {
            value = value.toString() + "0";
        }
        price = value;
    }
    return price;
})


//用户管理   -  角色转换
Vue.filter('roleFilter', function (val) {
    var role = val;
    switch (val) {
        case 'user': role = '普通用户'; break;
        case 'admin': role = '管理员'; break;
        case 'sysadmin': role = '超级管理员'; break;
        default: role = val;
    }
    return role;
})


//用户管理  -  用户状态
Vue.filter('status', function (val) {
    var status = val;
    switch (val) {
        case 1: status = '启用'; break;
        case 2: status = '禁用'; break;
        case 3: status = '删除'; break;
    }
    return status;
})


//商户 用户来源转换
Vue.filter('userTransformation', function (value) {
    let val = "";
    switch (value) {
        case 1: val = '商城'; break;
        case 2: val = 'crm'; break;
        case 3: val = '短信平台'; break;
        default: val = "商城";
    }
    return val;
})


//个人认证    状态
Vue.filter('personalStatus', function (value) {
    let val = "";
    switch (value) {
        case 1: val = '已通过'; break;
        case 2: val = '已通过'; break;
        case 3: val = '待审核'; break;
        case 4: val = '审核不通过'; break;
        default: val = value;
    }
    return val;
})

//企业认证    状态
Vue.filter('enterpriseStatus', function (value) {
    let val = "";
    switch (value) {
        case 1: val = '已通过'; break;
        case 2: val = '已通过'; break;
        case 3: val = '待审核'; break;
        case 4: val = '审核不通过'; break;
        default: val = value;
    }
    return val;
})

//线下充值     汇款状态
Vue.filter('remittanceStatus', function (value) {
    let val = "";
    switch (value) {
        case 1: val = '待收款'; break;
        case 2: val = '待充值'; break;
        case 3: val = '已充值'; break;
        default: val = value;
    }
    return val;
})

//代理商     状态
Vue.filter('agentManagementStatus', function (value) {
    let val = "";
    switch (value) {
        case 0: val = '待响应'; break;
        case 1: val = '沟通中'; break;
        case 2: val = '已关闭'; break;
        case 3: val = '已成交'; break;
        default: val = "待响应";
    }
    return val;
})





// WEBPACK FOOTER //
// ./src/util/filter.js